<template>
    <div>
        <b-form-input v-model="inputValue" required class="form-control px-2" @input="fetchOptions" v-b-tooltip.hover :title="inputValue"/>
        <ul v-if="showOptions">
            <li v-for="option in options" :key="option.id" @click="selectOption(option)">
                {{ option.cod4 + ' '+option.description4_codes }}
            </li>
        </ul>
    </div>
</template>
  
<script>
import medicionAusentismoAPI from "@/services/standards/medicionAusentismo/medicionAusentismoAPI";

export default {
    data() {
        return {
            inputValue: '',
            options: [],
            showOptions: false,
        };
    },
    methods: {
        fetchOptions() {
            medicionAusentismoAPI.getCode({ search: this.inputValue })
                .then(response => {
                    this.options = response.data;
                    this.showOptions = true;
                })
                .catch(error => {
                    console.error('Error fetching options', error);
                });
        },
        selectOption(option) {
            this.inputValue = option.cod4 + ' ' + option.description4_codes;
            this.showOptions = false;
            this.$emit('option-selected', option);
        },
        closeOptionsList() {
            this.showOptions = false;
        },
    },
    mounted() {
        // Agregar un manejador de clic en el documento para cerrar la lista
        document.addEventListener('click', this.closeOptionsList);
    },
    beforeDestroy() {
        // Eliminar el manejador de clic al destruir el componente
        document.removeEventListener('click', this.closeOptionsList);
    },
};
</script>

  
<style scoped>
/* Estilos CSS opcionales para el componente */
ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    border: 1px solid #ccc;
}

li {
    padding: 8px;
    cursor: pointer;
    color: #000000;

    &:hover {
        /* background-color: #f0f0f0; */
        background-color: #00707f;
    }
}
</style>